import React, { useState } from 'react';
import {
   Box,
   Dialog,
   DialogTitle,
   DialogContent,
   DialogContentText,
   DialogActions,
   Button,
} from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/pro-duotone-svg-icons';

const Message = ({
   title,
   content,
   handleClose,
   open,
   buttonLabel,
   variant,
}) => {
   return (
      <Dialog
         disableBackdropClick
         onClose={handleClose}
         aria-labelledby='simple-dialog-title'
         open={open}
         fullWidth={true}
      >
         <DialogTitle id='simple-dialog-title'>
            <Box display={'flex'}>
               {variant === 'error' && (
                  <Box mr={1}>
                     <FontAwesomeIcon
                        icon={faExclamationTriangle}
                        color={'red'}
                        size={'1000px'}
                     />
                  </Box>
               )}
               {title}
            </Box>
         </DialogTitle>
         <DialogContent>
            <DialogContentText>{content}</DialogContentText>
         </DialogContent>
         <DialogActions>
            <Button autoFocus onClick={handleClose} color='primary'>
               {buttonLabel}
            </Button>
         </DialogActions>
      </Dialog>
   );
};

export default Message;
